/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * LogInIcon
 */
export default class LogInIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M19 2h-4c-.6 0-1 .4-1 1s.4 1 1 1h4c.6 0 1 .4 1 1v14c0 .6-.4 1-1 1h-4c-.6 0-1 .4-1 1s.4 1 1 1h4c1.7 0 3-1.3 3-3V5c0-1.7-1.3-3-3-3zm-3.1 10.4c.1-.2.1-.5 0-.8-.1-.1-.1-.2-.2-.3l-5-5c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l3.3 3.3H3c-.6 0-1 .4-1 1s.4 1 1 1h9.6l-3.3 3.3c-.4.4-.4 1 0 1.4.2.2.4.3.7.3.3 0 .5-.1.7-.3l5-5c.1-.1.2-.2.2-.3z"/><g fillRule="evenodd"><use/><use fillRule="nonzero"/></g></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

